/// <reference path="../_all.ts" />

module editor {
  'use strict';
  
  var escape = new RegExp('[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\^\\$\\|]', 'g');

  export interface IKeyboardShortcut extends ng.IFilterService {
      (name: 'keyboardShortcut'): (str: string) => string;
  }
  
  KeyboardShortcut.$inject = ['$window'];
  export function KeyboardShortcut($window : ng.IWindowService) {
    return function (str : string) : string {
      if (!str) return;
      var keys = str.split('-');
      var isOSX = /Mac OS X/.test($window.navigator.userAgent);

      var seperator = (!isOSX || keys.length > 2) ? '+' : '';

      var abbreviations = {
        M: isOSX ? '⌘' : 'Ctrl',
        A: isOSX ? 'Option' : 'Alt',
        S: 'Shift'
      };

      return keys.map(function(key, index) {
        var last = index == keys.length - 1;
        return last ? key : abbreviations[key];
      }).join(seperator);
    }  
        
  }
}


